import { render } from "./DynamicReports.vue?vue&type=template&id=b82e567e&scoped=true"
import script from "./DynamicReports.vue?vue&type=script&lang=js"
export * from "./DynamicReports.vue?vue&type=script&lang=js"

import "./DynamicReports.vue?vue&type=style&index=0&id=b82e567e&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82e567e"]])

export default __exports__